export default __webpack_public_path__ + "media/color/apex-fc632b0c.svg";